export default "__VITE_ASSET__rzjKlgkF__"